/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withMagicApronTNT } from '@thd-olt-component-middleware/pip';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleG5Index0K0Header }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleG5Index1K0Header }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleG5Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleG5Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotG4Placeholder0 = null;

const SlotG4Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotG4Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotG4Index0Client,
  placeholder: SlotG4Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_G4 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G4 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_G4, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'above-accordion' } });

lazySlots.LazyBotPromptG4 = withLayout(

  [

    SlotG4Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_G4
  ,

  [

    {
      waitForComponent: SlotG4Index0Client,
      placeholder: SlotG4Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG5Placeholder0K0 = null;

const SlotG5Index0ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/product-overview');
};

export const SlotG5Index0LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
      .ProductOverviewAccordionBody;
  },
  client: SlotG5Index0ClientK0,
  placeholder: SlotG5Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'ProductOverviewAccordionBody',
});

lazySlots.LazyProductOverviewAccordionBodyG5 = withLayout(
  SlotG5Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotG5Index0ClientK0,
    placeholder: SlotG5Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotG5Placeholder1K0 = null;

const SlotG5Index1ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/specifications');
};

export const SlotG5Index1LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
      .SpecificationsWithKPFAccordionBody;
  },
  client: SlotG5Index1ClientK0,
  placeholder: SlotG5Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'SpecificationsWithKPFAccordionBody',
});

lazySlots.LazySpecificationsWithKPFAccordionBodyG5 = withLayout(
  SlotG5Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotG5Index1ClientK0,
    placeholder: SlotG5Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotG5Placeholder2K0 = null;

const SlotG5Index2ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotG5Index2LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
      .QuestionsAndAnswersAccordionBody;
  },
  client: SlotG5Index2ClientK0,
  placeholder: SlotG5Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazyQuestionsAndAnswersAccordionBodyG5 = withLayout(
  SlotG5Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotG5Index2ClientK0,
    placeholder: SlotG5Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotG5Placeholder3K0 = null;

const SlotG5Index3ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotG5Index3LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
      .RatingsAndReviewsAccordionBody;
  },
  client: SlotG5Index3ClientK0,
  placeholder: SlotG5Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazyRatingsAndReviewsAccordionBodyG5 = withLayout(
  SlotG5Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotG5Index3ClientK0,
    placeholder: SlotG5Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

const LazyG5Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        ProductOverviewAccordionTitleG5Index0K0Header,

      ),

    ],

    [

      withLayout(
        SpecificationsAccordionTitleG5Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleG5Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleG5Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazyProductOverviewAccordionBodyG5,

    ],

    [

      lazySlots.LazySpecificationsWithKPFAccordionBodyG5,

    ],

    [

      lazySlots.LazyQuestionsAndAnswersAccordionBodyG5,

    ],

    [

      lazySlots.LazyRatingsAndReviewsAccordionBodyG5,

    ],

  ]
],

null
);

const SlotG6Placeholder0 = null;

const SlotG6Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotG6Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotG6Index0Client,
  placeholder: SlotG6Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_G6 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G6 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_G6, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'default', default: true } });

lazySlots.LazyBotPromptG6 = withLayout(

  [

    SlotG6Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_G6
  ,

  [

    {
      waitForComponent: SlotG6Index0Client,
      placeholder: SlotG6Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG15Placeholder0 = null;

const SlotG15Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "featurebasedrecommendationsimporter" */
    '@thd-olt-component-react/feature-based-recommendations');
};

export const SlotG15Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/feature-based-recommendations'))
      .FeatureBasedRecommendationsImporter;
  },
  client: SlotG15Index0Client,
  placeholder: SlotG15Placeholder0 || getPlaceholder({ skip: true }),
  name: 'FeatureBasedRecommendationsImporter',
});

lazySlots.LazyFeatureBasedRecommendationsImporterG15 = withLayout(

  [

    SlotG15Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotG15Index0Client,
      placeholder: SlotG15Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG23Placeholder0 = null;

const SlotG23Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "emtlinks" */
    '@thd-olt-component-react/emt-links');
};

export const SlotG23Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/emt-links'))
      .EmtLinks;
  },
  client: SlotG23Index0Client,
  placeholder: SlotG23Placeholder0 || getPlaceholder({ skip: true }),
  name: 'EmtLinks',
});

lazySlots.LazyEmtLinksG23 = withLayout(

  [

    SlotG23Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotG23Index0Client,
      placeholder: SlotG23Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  const ssr = typeof window === 'undefined';
  const decisionIndex = ssr
    ? 0
    : Number(
      (window.__SLOT_DECISIONS__ && window.__SLOT_DECISIONS__[props.slot]) ?? '0'
    );

  if (props.slot === 'slotG4') {

    return (
      <lazySlots.LazyBotPromptG4
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG4"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="6.9.9"
      />
    );

  }

  if (props.slot === 'slotG5') {

    return (
      <LazyG5Accordion
        {...props}
        config={props.config}
        fusionSlotName="slotG5"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  if (props.slot === 'slotG6') {

    return (
      <lazySlots.LazyBotPromptG6
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG6"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="6.9.9"
      />
    );

  }

  if (props.slot === 'slotG15') {

    return (
      <lazySlots.LazyFeatureBasedRecommendationsImporterG15
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG15"
        fusionComponentName="@thd-olt-component-react/feature-based-recommendations"
        version="9.0.1"
      />
    );

  }

  if (props.slot === 'slotG23') {

    return (
      <lazySlots.LazyEmtLinksG23
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG23"
        fusionComponentName="@thd-olt-component-react/emt-links"
        version="9.3.1"
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};
